import { render, staticRenderFns } from "./add-model-modal.vue?vue&type=template&id=31297d44&"
import script from "./add-model-modal.vue?vue&type=script&lang=js&"
export * from "./add-model-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports